import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    useCartContext,
    useModalsContext,
    useStoreConfigContext
} from '/src/providers';
import { Modal, ButtonCheckout } from '/src/components';
import { googleBeginCheckout } from '/src/services';
import CartProducts from './CartProducts';
import * as styles from './styles.scss';

const Cart = () => {
    const navigate = useNavigate();
    const { translate, formatPrice } = useStoreConfigContext();
    const {
        cart: {
            billing_address,
            shipping_addresses,
            selected_payment_method,
            prices: {
                grand_total,
            } = {},
            prices,
            itemsV2: { items = [] } = {},
        },
        isCartItems,
        isLoadingCart,
    } = useCartContext();
    const { hideModal } = useModalsContext();

    const handleRedirectToCheckout = () => {
        const isLastStep = !!billing_address
            && shipping_addresses.find(({ selected_shipping_method }) => selected_shipping_method)
            && !!Object.values(selected_payment_method).some(e => !!e);

        googleBeginCheckout({ items, prices });

        if (isLastStep) {
            navigate('/checkout/order');
        } else {
            navigate('/checkout');
        }
        hideModal();
    };

    return (
        <Modal { ...(!isLoadingCart ? { toggle: hideModal } : {}) }>
            <div className={styles.title}>
                {!isCartItems && !isLoadingCart && translate('Cart is empty')}
                {!isCartItems && isLoadingCart && translate('Loading')}
            </div>
            {isCartItems && <CartProducts onClose={hideModal} />}
            {
                !!grand_total &&
                <div className={styles.total}>
                    <div className={styles.name}>
                        {translate('Grand total')}
                    </div>
                    <div className={styles.grand}>
                        {formatPrice(grand_total)}
                    </div>
                </div>
            }
            <div className={styles.actions}>
                <button
                    className={styles.link}
                    onClick={
                        () => { navigate('/basket'); hideModal(); }
                    }
                >
                    {translate('Basket')}
                </button>
                <ButtonCheckout
                    onClick={handleRedirectToCheckout}
                >
                    {translate('Proceed to checkout')}
                </ButtonCheckout>
            </div>
        </Modal>
    );
};

export default Cart;
